import type { TileArgs } from 'react-calendar/src/shared/types';
import { DateTime } from 'luxon';

const isTileDisabledForDate = (
    { date, view }: TileArgs,
    validDates: string[],
    value: Date[]
) => {
    if (view === 'month') {
        return !validDates.includes(DateTime.fromJSDate(date).toISODate());
    }

    if (view === 'year') {
        if (
            value.some(item => date.getMonth() === item.getMonth()) &&
            value.some(item => date.getFullYear() === item.getFullYear())
        ) {
            return false;
        }

        const validMonthsByYear = new Set(
            validDates.map(item => {
                const dateTime = DateTime.fromISO(item);
                return `${dateTime.year}-${dateTime.month}`;
            })
        );

        if (
            validMonthsByYear.has(
                // JS Date months are 0 indexed :/
                `${date.getFullYear()}-${date.getMonth() + 1}`
            )
        ) {
            return false;
        }
    }

    if (view === 'decade') {
        if (value.some(item => date.getFullYear() === item.getFullYear())) {
            return false;
        }

        const validYears = new Set(
            validDates.map(item => DateTime.fromISO(item).year.valueOf())
        );

        if (validYears.has(date.getFullYear())) {
            return false;
        }
    }

    return true;
};

export default isTileDisabledForDate;
